<span class="search-box-span">
  @if (showSearchIcon) {
    <i class="fa fa-search" (click)="onSearchIconClick()"></i>
  }

  <input  #searchComboBox class="search-box-input" type="text"
    [(ngModel)]="value"
    (change)="onSearchBoxSelectedChanged(searchComboBox.value)"
    (keyup.enter)="OnSearchBoxEnter()"
    (keyup)="OnSearchBoxKeyUp($event)"
    placeholder="{{placeHolderText}}" />

  </span>
